import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'threeStars'
})
export class ThreeStarsPipe implements PipeTransform {
  transform(value: string, args?: any): string {
    return '***' + value;
  }
}
